import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./texts.css";
import "./antd.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import toast, { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { persistor, store } from "./app/store";
import { PersistGate } from "redux-persist/integration/react";
import "react-phone-input-2/lib/style.css";

const _origError = toast.error.bind(toast);
const _origSuccess = toast.success.bind(toast);
toast.error = (msg, opts) => (msg ? _origError(msg, opts) : undefined);
toast.success = (msg, opts) => (msg ? _origSuccess(msg, opts) : undefined);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          duration: 5000,
        }}
      />
    </PersistGate>
  </Provider>,
);

reportWebVitals();
